import type { ItemMetadata } from './api.ts';

/**
 * Karar alanında gösterilecek tek puan.
 *
 * IMDb varsa o kullanılır (OMDb); yoksa TMDB puanına düşülür. İki puanı
 * yan yana göstermek küçük ekranda karar alanını kalabalıklaştırıyordu.
 */
export function preferredRating(
  metadata: Pick<ItemMetadata, 'imdbRating' | 'imdbVotes' | 'rating' | 'votes'>,
): { source: 'IMDb' | 'TMDB'; value: number; votes: number | null } | null {
  if (metadata.imdbRating !== null) {
    return { source: 'IMDb', value: metadata.imdbRating, votes: metadata.imdbVotes };
  }
  if (metadata.rating !== null) {
    return { source: 'TMDB', value: metadata.rating, votes: metadata.votes };
  }
  return null;
}

/** Uzun özeti cümle/kelime sınırına yakın kısaltır; tam metin ayrıca açılır. */
export function overviewPreview(
  overview: string,
  maxLength = 280,
): { text: string; truncated: boolean } {
  const trimmed = overview.trim();
  if (trimmed.length <= maxLength) return { text: trimmed, truncated: false };

  const cut = trimmed.slice(0, maxLength);
  const lastSpace = cut.lastIndexOf(' ');
  const safeCut = lastSpace > maxLength * 0.6 ? cut.slice(0, lastSpace) : cut;
  return { text: `${safeCut.trimEnd()}…`, truncated: true };
}
